import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { ArrowLeft, Cookie, Settings, BarChart3, Shield } from "lucide-react";

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 font-mono text-sm text-zinc-500 hover:text-primary transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          VOLVER
        </Link>

        <div className="bg-[#111] border border-zinc-800 p-8">
          <div className="flex items-center gap-3 mb-8">
            <Cookie className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-black tracking-tighter">
              POLÍTICA DE <span className="text-primary">COOKIES</span>
            </h1>
          </div>

          <p className="text-zinc-400 mb-8 font-mono text-sm">
            Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          {/* Qué son las cookies */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Cookie className="w-5 h-5 text-primary" />
              1. ¿QUÉ SON LAS COOKIES?
            </h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Las cookies son pequeños archivos de texto que los sitios web almacenan en tu 
                dispositivo (ordenador, tablet o móvil) cuando los visitas. Se utilizan para 
                que el sitio web funcione correctamente, mejorar la experiencia de usuario y 
                proporcionar información a los propietarios del sitio.
              </p>
            </div>
          </section>

          {/* Tipos de cookies */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Settings className="w-5 h-5 text-primary" />
              2. TIPOS DE COOKIES QUE UTILIZAMOS
            </h2>
            <div className="text-zinc-400 space-y-4">
              
              {/* Cookies técnicas */}
              <div className="bg-[#0a0a0a] border border-zinc-800 p-4">
                <h3 className="text-white font-bold mb-2">COOKIES TÉCNICAS (Esenciales)</h3>
                <p className="mb-2">Son necesarias para el funcionamiento básico del sitio web.</p>
                <table className="w-full text-sm mt-3">
                  <thead>
                    <tr className="border-b border-zinc-800">
                      <th className="text-left py-2 text-zinc-300">Nombre</th>
                      <th className="text-left py-2 text-zinc-300">Finalidad</th>
                      <th className="text-left py-2 text-zinc-300">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-zinc-800/50">
                      <td className="py-2 font-mono text-xs">token</td>
                      <td className="py-2">Autenticación de sesión del usuario</td>
                      <td className="py-2">7 días</td>
                    </tr>
                    <tr className="border-b border-zinc-800/50">
                      <td className="py-2 font-mono text-xs">cookie_consent</td>
                      <td className="py-2">Recordar preferencias de cookies</td>
                      <td className="py-2">1 año</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Cookies de preferencias */}
              <div className="bg-[#0a0a0a] border border-zinc-800 p-4">
                <h3 className="text-white font-bold mb-2">COOKIES DE PREFERENCIAS</h3>
                <p className="mb-2">Permiten recordar tus preferencias de navegación.</p>
                <table className="w-full text-sm mt-3">
                  <thead>
                    <tr className="border-b border-zinc-800">
                      <th className="text-left py-2 text-zinc-300">Nombre</th>
                      <th className="text-left py-2 text-zinc-300">Finalidad</th>
                      <th className="text-left py-2 text-zinc-300">Duración</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-zinc-800/50">
                      <td className="py-2 font-mono text-xs">theme</td>
                      <td className="py-2">Preferencia de tema (oscuro)</td>
                      <td className="py-2">1 año</td>
                    </tr>
                    <tr className="border-b border-zinc-800/50">
                      <td className="py-2 font-mono text-xs">city_preference</td>
                      <td className="py-2">Ciudad seleccionada por defecto</td>
                      <td className="py-2">30 días</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Cookies analíticas */}
              <div className="bg-[#0a0a0a] border border-zinc-800 p-4">
                <h3 className="text-white font-bold mb-2">COOKIES ANALÍTICAS (Opcionales)</h3>
                <p className="mb-2">Nos ayudan a entender cómo los usuarios interactúan con el sitio.</p>
                <p className="text-zinc-500 text-sm">
                  Actualmente NO utilizamos cookies analíticas de terceros como Google Analytics. 
                  Solo recopilamos estadísticas básicas de uso a través de nuestros propios servidores.
                </p>
              </div>
            </div>
          </section>

          {/* Base legal */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Shield className="w-5 h-5 text-primary" />
              3. BASE LEGAL
            </h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                De acuerdo con la normativa española (LSSI-CE) y europea (RGPD):
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong className="text-zinc-300">Cookies técnicas:</strong> No requieren consentimiento 
                  ya que son estrictamente necesarias para el funcionamiento del servicio.
                </li>
                <li>
                  <strong className="text-zinc-300">Cookies de preferencias y analíticas:</strong> Requieren 
                  tu consentimiento previo, que puedes gestionar desde el banner de cookies o desde 
                  la configuración de tu navegador.
                </li>
              </ul>
            </div>
          </section>

          {/* Cómo gestionar */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <BarChart3 className="w-5 h-5 text-primary" />
              4. CÓMO GESTIONAR LAS COOKIES
            </h2>
            <div className="text-zinc-400 space-y-4">
              <p>
                Puedes gestionar tus preferencias de cookies de las siguientes formas:
              </p>
              
              <div className="bg-[#0a0a0a] border border-zinc-800 p-4">
                <h3 className="text-white font-bold mb-2">Desde nuestro sitio web</h3>
                <p>
                  Haz clic en el botón "Configurar cookies" del banner que aparece al visitar 
                  el sitio, o accede a la configuración desde el footer de cualquier página.
                </p>
              </div>

              <div className="bg-[#0a0a0a] border border-zinc-800 p-4">
                <h3 className="text-white font-bold mb-2">Desde tu navegador</h3>
                <p className="mb-2">Puedes configurar tu navegador para bloquear o eliminar cookies:</p>
                <ul className="list-disc list-inside space-y-1 ml-4 text-sm">
                  <li>
                    <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                      Google Chrome
                    </a>
                  </li>
                  <li>
                    <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                      Mozilla Firefox
                    </a>
                  </li>
                  <li>
                    <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                      Safari
                    </a>
                  </li>
                  <li>
                    <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-cookies-en-microsoft-edge" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                      Microsoft Edge
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Consecuencias */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">5. CONSECUENCIAS DE DESACTIVAR LAS COOKIES</h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Si desactivas las cookies técnicas, es posible que algunas funcionalidades del 
                sitio no funcionen correctamente:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>No podrás mantener la sesión iniciada</li>
                <li>Tus preferencias no se guardarán entre visitas</li>
                <li>Algunas funciones interactivas pueden no estar disponibles</li>
              </ul>
            </div>
          </section>

          {/* Actualizaciones */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">6. ACTUALIZACIONES DE ESTA POLÍTICA</h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Podemos actualizar esta Política de Cookies periódicamente. Te notificaremos 
                sobre cambios significativos mediante un aviso en nuestro sitio web o por email 
                si tienes una cuenta registrada.
              </p>
            </div>
          </section>

          {/* Contacto */}
          <section>
            <h2 className="text-xl font-bold text-white mb-4">7. CONTACTO</h2>
            <div className="text-zinc-400">
              <p>
                Para cualquier consulta sobre esta Política de Cookies, puedes contactarnos en:{" "}
                <a href="mailto:privacidad@rockmaps.es" className="text-primary hover:underline">
                  privacidad@rockmaps.es
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
